module.exports = __webpack_public_path__ + "static/media/sun-glasses-8.473d2d05.jpeg";